export const LOCATION_HIGHLIGHTED = '#dbe7f8'
export const LOCATION_UNHIGHLIGTHED = '#f7f7f7'

// Opacity values for IMUP selection/non-selection in Paper.js
export const ACTIVE_OPACITY_VALUE = 0.8
export const INACTIVE_OPACITY_VALUE = 0.5
export const LOCKED_OPACITY_VALUE = 0.25

export const GRAY_400 = '#98A2B3'
export const GRAY_500 = '#667085'
export const GRAY_600 = '#475467'
export const GRAY_700 = '#344054'
export const PRIMARY_200 = '#81A2D8'
export const PRIMARY_300 = '#5481C7'
export const WHITE = '#fff'
export const BLACK = '#000'

export const REGION_COLOR = '#0e6db6'

export const JOIST_COLOR = {
    WHITE: '#fff',
    BLACK: '#000',
    BLUE: '#005B96',
}

export const MASTER_SET_PLAN_COLOR = {
    OPTION: '#73E2A3',
    BASE_HOME: '#0E9384',
}

export const COLORS = {
    SUCCESS: '#047857',
    ERROR: '#600414',
} as const
